import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faMapMarkerAlt, faUsers, faTag, faBeer } from '@fortawesome/free-solid-svg-icons';

class EventInfo extends Component {
    render() {
        const { date, venue, cost, stein, steinCost, registrationDeadline, steinOrderDeadline, description, registrationCount, registrationLimit } = this.props.event;
        return (
            <Row>
                <Col>
                    <h3>Tudnivalók</h3>
                    <Row className="mb-3">
                        <Col md>
                            <FontAwesomeIcon icon={faCalendarAlt} size="2x" /><br />
                            {new Date(date).toLocaleString("hu")}
                        </Col>
                        <Col md>
                            <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" /><br />
                            {venue}
                        </Col>
                        <Col md>
                            <FontAwesomeIcon icon={faUsers} size="2x" /><br />
                            {registrationLimit - registrationCount} szabad hely
                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col md>
                            <FontAwesomeIcon icon={faTag} size="2x" /><br />
                            Részvételi díj: {cost} JMF<br />
                            Jelentkezési határidő:<br />
                            {new Date(registrationDeadline).toLocaleString("hu")}
                        </Col>
                        {stein && <Col md>
                            <FontAwesomeIcon icon={faBeer} size="2x" /><br />
                            Korsó ára: {steinCost} JMF<br />
                            Korsórendelési határidő:<br />
                            {new Date(steinOrderDeadline).toLocaleString("hu")}
                        </Col>}
                    </Row>
                    <Row>
                        <Col dangerouslySetInnerHTML={{ __html: description }}>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default EventInfo;